@if (!isLiteral() && !isSourceQuestion()) {
<div
  class="tag"
  [ngClass]="{ error: hasError() }"
  (mouseenter)="mouseenter()"
  (mouseleave)="mouseleave()"
>
  <span>{{ name() }}</span>
  <div class="delete icon" (click)="deleteClicked()"></div>
</div>
} @if (isSourceQuestion()) {
<div class="source-question-container">
  <app-calc-source-question
    [sourceQuestion]="calcInput.field"
    [prefix]="prefix()"
  ></app-calc-source-question>
  <div class="delete icon" (click)="deleteClicked()"></div>
</div>
} @if (isLiteral() && literalTypeFormControl) {
<div class="literal">
  @if (literalTypeFormControl.value === 'Text') {
  <app-text-field
    class="inline"
    [myFormControl]="literalFormControl"
    [question]="{ answers: [] }"
  ></app-text-field>
  } @if (literalTypeFormControl.value === 'Paragraph') {
  <app-text-area
    class="inline"
    [myFormControl]="literalFormControl"
    [question]="{ answers: [] }"
  ></app-text-area>
  } @if (literalTypeFormControl.value === 'Number') {
  <app-number-field
    class="inline"
    [myFormControl]="literalFormControl"
    [question]="{ answers: [] }"
  ></app-number-field>
  } @if (literalTypeFormControl.value === 'Date') {
  <app-date-field
    class="inline"
    [myFormControl]="literalFormControl"
    [question]="{ answers: [] }"
  ></app-date-field>
  }
  <select [formControl]="literalTypeFormControl">
    @for (literalType of literalTypes; track literalType) {
    <option [value]="literalType">{{ literalType }}</option>
    }
  </select>
  <div class="delete icon" (click)="deleteClicked()"></div>
</div>
}
